(function () {
	'use strict';

	var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

	require('document-outline');
	require('smooth-scroll');

	// Use it
	$('[data-in-page-menu]').each(function () {
		var menu = $(this);
		var doc = $(menu.attr('data-in-page-menu'));

		doc.documentOutline(menu);
		menu.find('a').smoothScroll({offset: -70});
	});
})();
